export default __webpack_public_path__ + "static/media/KZ.T.19.2320.8c526248.svg";